module.exports = __webpack_public_path__ + "static/aws-sap-bf53ab8fb0a67761be5603bab989c6ae.png";